import React from "react";
import DocumentTable from "./DocumentTable";

function DocumentOverview() {
  return (
    <div style={{paddingBottom:'24px'}}>
      <DocumentTable />
    </div>
  );
}

export default DocumentOverview;
